import ScalarTeleportRoot_vue_vue_type_script_setup_true_lang_default from "./ScalarTeleportRoot.vue.script.js";
//#region src/components/ScalarTeleport/ScalarTeleportRoot.vue
var ScalarTeleportRoot_default = ScalarTeleportRoot_vue_vue_type_script_setup_true_lang_default;
//#endregion
export { ScalarTeleportRoot_default as default };

//# sourceMappingURL=ScalarTeleportRoot.vue.js.map